import { Box, CircularProgress, Dialog, DialogTitle, DialogContent, IconButton, Skeleton } from "@mui/material";
import { Colors } from "../../helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

type Props = {
  open: boolean;
  handleClose: () => void;
  fullScreen:boolean;
};

export default function FoodDialogLoading({open, handleClose, fullScreen}: Props){
  return(
    <Dialog
      fullScreen={ fullScreen }
      open={open}
      onClose={ () => handleClose() }
      maxWidth={"lg"}
    >
    <DialogTitle color={Colors.orangePrimary}>
      <Box display="flex" alignItems="center">
        <Box>
          <IconButton color="primary" onClick={ () => handleClose() } >
            <ArrowBackIosIcon fill={Colors.orangePrimary} />
          </IconButton>
        </Box>
        <Box
          flexGrow={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Carregando ...
        </Box>
      </Box>
    </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { md: "600px" },
            height: "100%",
          }}
        >
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{
              borderRadius: "7px",
              width: "100%",
              height: {
                xs: "180px",
                sm: "200px",
                md: "280px",
              },
            }}
          />
          <Skeleton variant="text" sx={{ width: "40%" }} animation="wave" />
          <Skeleton variant="text" sx={{ width: "20%" }} animation="wave" />
          <Skeleton variant="text" sx={{ width: "40%" }} animation="wave" />
          <Skeleton variant="text" sx={{ width: "20%" }} animation="wave" />
          <hr/>
        </Box>
      </DialogContent>
  </Dialog>
  );
}